import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Base_Url } from '../config';

const EditRoutes = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        routes: '',
        iscard: false,
        ispage: false,
        isroutesisused: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Fetch existing route data
    useEffect(() => {
        const fetchRouteData = async () => {
            try {
                const response = await axios.get(`${Base_Url}/createroutes/${id}`);
                setFormData({
                    routes: response.data.routes || '',
                    iscard: response.data.iscard || false,
                    ispage: response.data.ispage || false,
                    isroutesisused: response.data.isroutesisused || false
                });
            } catch (err) {
                console.error('Failed to fetch route data', err);
                setError('Failed to load route data. Please try again.');
            }
        };

        if (id) {
            fetchRouteData();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        setFormData(prevData => {
            const newData = {
                ...prevData,
                [name]: type === 'checkbox' ? checked : value
            };

            // If ispage is checked, uncheck iscard
            if (name === 'ispage' && checked) {
                newData.iscard = false;
            }
            
            // If iscard is checked, uncheck ispage
            if (name === 'iscard' && checked) {
                newData.ispage = false;
            }

            return newData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const payload = {
                ...formData,
                routes: formData.routes.startsWith('/') ? formData.routes : `/${formData.routes}`
            };
            
            await axios.put(`${Base_Url}/createroutes/${id}`, payload);
            setSuccess('Route updated successfully!');
            setTimeout(() => {
                navigate('/add-routes');
            }, 1000);
        } catch (err) {
            console.error('Failed to update route', err);
            setError(err.response?.data?.message || 'Failed to update route. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow mb-4">
                        <div className="card-header bg-danger text-white">
                            <h3 className="mb-0 text-white">Edit Route</h3>
                        </div>
                        <div className="card-body">
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}
                            {success && (
                                <div className="alert alert-success" role="alert">
                                    {success}
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="routes" className="form-label">
                                        Route Path <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="routes"
                                        name="routes"
                                        value={formData.routes}
                                        onChange={handleChange}
                                        placeholder="Enter route path (e.g. /services)"
                                        required
                                    />
                                    <small className="text-muted">
                                        Route should start with a forward slash (/)
                                    </small>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="iscard"
                                                name="iscard"
                                                checked={formData.iscard}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="iscard">
                                                Is Card
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="ispage"
                                                name="ispage"
                                                checked={formData.ispage}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="ispage">
                                                Is Page
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="form-check mb-3">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isroutesisused"
                                        name="isroutesisused"
                                        checked={formData.isroutesisused}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="isroutesisused">
                                        Is Route Used
                                    </label>
                                </div> */}

                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary text-white bg-danger btn-outline-danger"
                                        disabled={loading}
                                    >
                                        {loading ? 'Updating...' : 'Update Route'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditRoutes;